export const getFormattedTestId = (value: string, postfix?: string) => {
  const formattedTestId = value
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase()

  return `${formattedTestId}${postfix}`
}
